import { RemarkGeneratedEntity } from "./generated/RemarkGeneratedEntity";

export abstract class RemarkEntity extends RemarkGeneratedEntity {
    // Comment to preserve new line
}
